import { render, staticRenderFns } from "./TaskNotes.vue?vue&type=template&id=237cd7be&scoped=true&"
import script from "./TaskNotes.vue?vue&type=script&lang=js&"
export * from "./TaskNotes.vue?vue&type=script&lang=js&"
import style0 from "./TaskNotes.vue?vue&type=style&index=0&id=237cd7be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237cd7be",
  null
  
)

export default component.exports